import React from 'react';

function ContactInfo() {
  return (
    <aside className="contact-info reveal reveal-d2">
      <InfoCard
        icon={<LocationIcon />}
        title="Address"
        text="Head Office - B-231, First Floor, Greater Kailash Part I, New Delhi-110048"
      />
      <InfoCard
        icon={<PhoneIcon />}
        title="Phone"
        text="011 45092961"
        href="tel:01145092961"
      />
      <InfoCard
        icon={<MailIcon />}
        title="Email"
        text="info@stupadev.com"
        href="mailto:info@stupadev.com"
      />
      <SocialRow />
    </aside>
  );
}

function InfoCard({ icon, title, text, href }) {
  return (
    <div className="contact-info-card">
      <div className="contact-info-icon">{icon}</div>
      <div>
        <h4 className="contact-info-title">{title}</h4>
        {href ? (
          <a href={href} className="contact-info-link">{text}</a>
        ) : (
          <p className="contact-info-text">{text}</p>
        )}
      </div>
    </div>
  );
}

function SocialRow() {
  return (
    <div className="contact-social-row">
      <h4 className="contact-info-title">Follow Us</h4>
      <div className="contact-social-links">
        <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="contact-social-link" aria-label="LinkedIn">IN</a>
      </div>
    </div>
  );
}

function LocationIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="24" height="24">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  );
}

function PhoneIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="24" height="24">
      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
    </svg>
  );
}

function MailIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="24" height="24">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
      <polyline points="22,6 12,13 2,6" />
    </svg>
  );
}

export default ContactInfo;
